import SiteData from "../../types/SiteData";
import { Action } from "../actions";

export type SiteDataState = SiteData & {

};

export const siteDataInitialState: SiteDataState = {
    heroes: [],
    banners: [],
    games: [],
    heroColors: [],
    heroWeapons: [],
    heroMoveTypes: [],
    heroAbilities: [],
    heroSources: [],
    heroSummoningPools: [],
    heroThemes: [],
    feats: []
}

export const siteDataReducer = (state: SiteDataState, action: Action): SiteDataState => {
    switch (action.type) {
        case "SET_SITE_DATA":
            return { ...action.data };
        default:
            return state;
    }
}
